export default "/images/967b9499f1186011ad454c24797c83ca.avif";